import { EVENT_TABS_IDS } from '../../model/consts';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import styles from './event-sminex-club-switcher.module.scss';

interface EventSminexClubSwitcherProps {
  activeTabId: number;
  onChange: (tabId: number) => void;
}

const SWITCHER_BLOCKS = ['Список участников', 'Организаторы'];

export const EventSminexClubSwitcher = ({ activeTabId, onChange }: EventSminexClubSwitcherProps) => {
  const switcherTabIds = [EVENT_TABS_IDS.LIST_PARTICIPANTS, EVENT_TABS_IDS.ORGANIZERS];
  const activeIndex = Math.max(switcherTabIds.indexOf(activeTabId), 0);

  const handleChange = (index: number) => {
    const tabId = switcherTabIds[index];

    if (tabId === undefined) {
      return;
    }

    onChange(tabId);
  };

  const switcherItems = SWITCHER_BLOCKS.map((label, index) => {
    const isActive = activeIndex === index;

    return {
      key: label,
      label,
      className: `${styles.switcherItem} ${isActive ? styles.switcherItemActive : ''}`,
      onClick: () => handleChange(index),
    };
  });

  return (
    <div className={styles.switcher}>
      {switcherItems.map((item) => (
        <UnstyledButton key={item.key} type="button" className={item.className} onClick={item.onClick}>
          {item.label}
        </UnstyledButton>
      ))}
    </div>
  );
};
